import styled from 'styled-components'
import { NODE_DEFAULTS } from '../../../../../utils/nodeDefaults'
import { SPACING, TYPOGRAPHY, FONT_WEIGHT } from '../../../../../styles/theme'
import { getContrastingTextColor } from '../../../../../utils/colorUtils'
import { hexToRgba } from '../nodeHelpers'

// Preview overlay - fixed position portal that shows readable node on hover
// Position is pre-adjusted to keep within viewport bounds
export const PreviewOverlay = styled.div.attrs<{ $x: number; $y: number }>((props) => ({
  style: {
    left: `${props.$x}px`,
    top: `${props.$y}px`,
  },
}))`
  position: fixed;
  z-index: 10000;
  pointer-events: none;
  animation: zoomIn 0.2s ease-out forwards;
  transform-origin: left center;

  @keyframes zoomIn {
    from {
      opacity: 0;
      transform: scale(0.85);
    }
    to {
      opacity: 1;
      transform: scale(1.15);
    }
  }
`

// Preview card container - readable size version of the node
export const PreviewCard = styled.div<{ $gradientColor: string; $borderColor?: string }>`
  background:
    linear-gradient(
      to right,
      ${(props) => hexToRgba(props.$gradientColor, 0.025)} 0%,
      ${(props) => hexToRgba(props.$gradientColor, 0.015)} 20%,
      ${(props) => hexToRgba(props.$gradientColor, 0.008)} 50%,
      transparent 75%
    ),
    var(--color-node-bg);
  border: 1px solid
    ${(props) => (props.$borderColor ? props.$borderColor + '40' : 'var(--color-node-border)')};
  border-left: 2px solid ${(props) => props.$borderColor ?? props.$gradientColor};
  border-radius: 8px;
  min-width: ${NODE_DEFAULTS.width}px;
  max-width: ${NODE_DEFAULTS.maxWidth + 100}px;
  box-shadow: var(--shadow-node-preview);
`

// Preview header
export const PreviewHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm};
  padding: ${SPACING.sm} ${SPACING.md};
  background-color: transparent;
  border-bottom: 1px solid var(--color-node-header-border);
`

// Preview content
export const PreviewContent = styled.div`
  padding: ${SPACING.sm} ${SPACING.md};
  color: var(--color-text-primary);
  font-size: ${TYPOGRAPHY.body.fontSize};
  line-height: 1.4;
  white-space: pre-wrap;
  word-wrap: break-word;
`

// Preview label - solid color background with contrasting text
export const PreviewLabel = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  color: ${(props) => getContrastingTextColor(props.$color)};
  background: ${(props) => props.$color};
  padding: 3px 8px;
  border-radius: 4px;
`
